// ===========================================================================================
// Support für Bootstrap Popovers: einfach data-toggle="popover" mit v-popover ersetzen
//
// Voraussetzungen :
//  1. Funktion makePopover in der custom.js
//  2. Direktive in der main.js registrieren mit Vue.directive('popover', popover)
// ===========================================================================================
export default {
  inserted(el) {
    el._popover = window.makePopover(el)
    el._popover.create();
  },
  unbind(el) {
    if (el._popover) {
      el._popover.destroy();
    }
  }
}
